import { apiHelper } from '@/helpers/apiHelper'
import API from '@axios'

const API_URL = '/api/report'

export default {
  ...apiHelper(API_URL),

  getAllColumns: id => API.get(`${API_URL}/${id}/field`),

  getAllFilters: id => API.get(`${API_URL}/${id}/filter`),

  getGeneratedList: id => API.get(`${API_URL}/generated`),

  async generateReport(reportId, dataOps) {
    return API.put(`${API_URL}/generate/${reportId}`, dataOps)
  },
}
